import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
	default as AnalyticsReactContext,
	type AnalyticsReactContextInterface,
} from '@atlaskit/analytics-next-stable-react-context';

const ContextTypes = {
	getAtlaskitAnalyticsContext: PropTypes.func,
	getAtlaskitAnalyticsEventHandlers: PropTypes.func,
};

interface Props {
	children: React.ReactNode;
	/**
	 * Analytics context to pass into the modal. Can be returned from useAnalyticsContext();
	 */
	value: AnalyticsReactContextInterface;
}

/**
 * This provides both modern and legacy context. It intentionally does not attempt to capture any
 * context to re-provide as it is used at the root of a ReactDOM.render().
 */
export class LinkCreateModalProvider extends Component<Props, AnalyticsReactContextInterface> {
	static contextTypes = ContextTypes;
	static childContextTypes = ContextTypes;

	contextValue: AnalyticsReactContextInterface;

	constructor(props: Props) {
		super(props);

		const { getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers } = this.props.value;
		this.contextValue = {
			getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
			getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
		};
	}

	getChildContext = () => {
		return this.contextValue;
	};

	render() {
		const { children } = this.props;

		return (
			<AnalyticsReactContext.Provider value={this.contextValue}>
				{children}
			</AnalyticsReactContext.Provider>
		);
	}
}
